import { cartStore } from '@stores/cart';

export function useCart() {
    const { byouCart, updateCartOptions, updateCart, addDeliveryMode, removeDeliveryMode, consent, setConsent } =
        cartStore((state) => state);

    return { byouCart, updateCartOptions, updateCart, addDeliveryMode, removeDeliveryMode, consent, setConsent };
}
